import { Alert, Box, DialogContent } from '@mui/material';
import React, { FC, ReactNode } from 'react';

import {
  contentStyle,
  dialogContentStyles,
  filtersContainerStyle,
  warningAlertStyle,
} from '../chooseTemplateModal.styles';

interface IProps {
  filters: ReactNode;
  children: ReactNode;
}

export const ModalBodyShell: FC<IProps> = ({ filters, children }) => (
  <DialogContent sx={dialogContentStyles}>
    <Alert severity="warning" sx={warningAlertStyle} data-action="template_settings_warning">
      Selecting a template will take priority over your claim page settings
    </Alert>
    <Box sx={filtersContainerStyle}>{filters}</Box>
    <Box sx={contentStyle}>{children}</Box>
  </DialogContent>
);
